import classnames from 'classnames';
import { Checkbox } from '@doda/io-react/common';
import React, { ComponentProps } from 'react';
import styles from './index.module.scss';

/**
 * IndustryCheckListコンポーネントに渡されるプロパティを定義するインターフェース
 */
interface Props {
  /** チェックリスト項目のタイトル */
  title: string;
  /** チェックリスト項目の値 */
  value: ComponentProps<typeof Checkbox>['value'];
  /** 求人数（オプション） */
  numberOfJobs?: number;
  /** チェンジイベントハンドラー */
  onChange: ComponentProps<typeof Checkbox>['onChange'];
  /** チェック状態（オプション） */
  checked?: boolean;
  /** 子要素（オプション） */
  children?: React.ReactNode;
}

/**
 * IndustryCheckListは特定の業界に関連するチェックリスト項目を表示するコンポーネント
 *
 * @param {Props} props - コンポーネントに渡されるプロパティ
 * @returns {JSX.Element} - 業界のチェックリスト項目の要素
 */
export const IndustryCheckList: React.FC<Props> = ({
  title,
  value,
  numberOfJobs,
  onChange,
  checked,
  children,
}) => {
  return (
    <div className={styles.industryCheckList}>
      <Checkbox
        onChange={onChange}
        value={value ?? title}
        checked={checked ?? false}
        label={
          <span
            className={classnames(styles.industryCheckList__checkboxTitle, {
              [styles['industryCheckList__checkboxTitle--checked']]: checked,
            })}
          >
            {title}
            {numberOfJobs !== undefined && (
              <span className={styles.industryCheckList__numberOfJobs}>
                {`(${numberOfJobs.toLocaleString()})`}
              </span>
            )}
          </span>
        }
      />
      <ul>{children}</ul>
    </div>
  );
};
